import { Button, Stack } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { useDropzone } from "react-dropzone";
import { useUploadFileToBucketMutation } from "src/api/services/bucketApi";
import { useCallback } from "react";
import { useClinician } from "src/context/SessionProvider/ClinicianProvider";

const UploadButtons = () => {
  const [uploadFile] = useUploadFileToBucketMutation();
  const clinicianName = useClinician(
    (clinician) => `${clinician.first_name} ${clinician.last_name}`,
  );

  const uploadFitnessPlan = useCallback(
    async (files: File[]) => {
      if (files.length === 0) return;

      const file = files[0];
      await uploadFile({
        file,
        bucket: "resources",
        path: "plans/fitness",
        uploadedBy: clinicianName,
        title: "Fitness",
      });
    },
    [clinicianName, uploadFile],
  );

  const uploadNutritionPlan = useCallback(
    async (files: File[]) => {
      if (files.length === 0) return;

      const file = files[0];
      await uploadFile({
        file,
        bucket: "resources",
        path: "plans/nutrition",
        uploadedBy: clinicianName,
        title: "Nutrition",
      });
    },
    [clinicianName, uploadFile],
  );

  const fitnessDrop = useDropzone({ onDrop: uploadFitnessPlan });
  const nutritionDrop = useDropzone({ onDrop: uploadNutritionPlan });

  return (
    <Stack direction="row" gap={2}>
      <div {...fitnessDrop.getRootProps()}>
        <input {...fitnessDrop.getInputProps()} />
        <Button startIcon={<FileUploadOutlinedIcon />} variant="outlined">
          Upload Fitness Plan
        </Button>
      </div>
      <div {...nutritionDrop.getRootProps()}>
        <input {...nutritionDrop.getInputProps()} />
        <Button startIcon={<FileUploadOutlinedIcon />} variant="outlined">
          Upload Nutrition Plan
        </Button>
      </div>
    </Stack>
  );
};

export default UploadButtons;
